function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10,
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      fontFamily: "none",
      mixBlendMode: "normal",
      fill: "none",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 192V0h192v192z",
    style: {
      fill: "none"
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.93077 -4.08239 4.03652 1.95271 -11.39 -12.613)",
    style: {
      fill: "#37474f"
    },
    d: "M-24.567 36.762h12.7v2h-12.7z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(4.03652 -1.95271 1.93077 4.08239 -11.39 -12.61)",
    style: {
      fill: "#37474f"
    },
    d: "M13.462 36.893h2v12.7h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 24h8v108h-8z",
    style: {
      fill: "#37474f"
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 36h112v84H60Z",
    style: {
      fill: "#cfd8dc"
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 154c0-3.2 2.8-6 6-6s6 2.8 6 6-2.8 6-6 6-6-2.8-6-6m44 0c0-3.2 2.8-6 6-6s6 2.8 6 6-2.8 6-6 6-6-2.8-6-6",
    style: {
      fill: "#607d8b"
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 32h120v16H56Zm0 84h120v8H56Z",
    style: {
      fill: "#7d99a6",
      fillOpacity: 1
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16",
    style: {
      fill: "#ffb74d"
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 76H44c-4.4 0-8-3.6-8-8s3.6-8 8-8h52c4.4 0 8 3.6 8 8s-3.6 8-8 8z",
    style: {
      fill: "#455a64"
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 88v28l10.4 7.2L30 168h28l6-92s-4.4-16-20-16-28 12.4-28 28",
    style: {
      fill: "#455a64"
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140 68h12v36h-12zm-16 12h12v24h-12zm-16 8h12v16h-12z",
    style: {
      fill: "#ed7d31",
      fillOpacity: 1
    },
    transform: "matrix(1.11864 0 0 1.13136 -11.39 -12.61)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatter);
export default __webpack_public_path__ + "static/media/matter.1916b994bd3d92af91d59323d7a45a4d.svg";
export { ForwardRef as ReactComponent };